import { sortAlphabeticalArray } from 'utilitys/helpers/general';

import { useProjectTreeStore } from 'store/projectContract.store';
import { useUserStore } from 'store/user.store';

import { QueryParams, useQueryGetCommonResources } from 'api/queries/getCommonResources.query';

const commonResourcesKey: QueryParams['objectsList'] = ['users'];

const assigneeMapper = (i, isCurrenUser = false) => ({
    id: null,
    value: i.userName,
    label: `${i.lastName && i.lastName?.length > 0 ? `${i.firstName} ${i.lastName}` : i.firstName}${isCurrenUser ? ' (Current User)' : ''}`,
    assignee: { ...i, id: null },
});

export interface IAssigneeOptionsList {
    id: number | null;
    value: string;
    label: string;
    assignee: {
        userName: string;
        firstName: string;
        lastName: string;
        imageName: string;
        id: number | null;
    };
}

const unAssignedOption = {
    id: null,
    value: 'Unassigned',
    label: 'Unassigned',
    assignee: {
        id: null,
        userName: 'Unassigned',
        firstName: 'Unassigned',
        lastName: '',
        imageName: '',
    },
};

export const useAssigneeOptionsList = (isUnAssignedOption = true): IAssigneeOptionsList[] => {
    const user = useUserStore((state) => state.user);
    const { project } = useProjectTreeStore();
    const { data } = useQueryGetCommonResources({ objectsList: commonResourcesKey, projectId: project?.id });

    const currentUser = data?.users?.find((i) => i.userName === user?.username);

    const defaultAssigneeOptions = currentUser
        ? isUnAssignedOption
            ? [assigneeMapper(currentUser, true), unAssignedOption]
            : [assigneeMapper(currentUser, true)]
        : isUnAssignedOption
          ? [unAssignedOption]
          : [];

    return data?.users
        ? [
              ...defaultAssigneeOptions,
              ...sortAlphabeticalArray(
                  data.users.map((item) => assigneeMapper(item)),
                  'label',
                  'asc',
              ),
          ]
        : [];
};
